import { Component } from 'react';
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'

class SaveAlertDialog extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { isConfirmDialoagOpen, onDontSave, onSave } = this.props
    return (
      <Dialog
        open={isConfirmDialoagOpen}
        onClose={onDontSave}
        aria-labelledby="responsive-dialog-title"
        style={{zIndex: 1500}}
      >
        <DialogTitle id="responsive-dialog-title">
          {'Unsaved Changes'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have unsaved changes! Exit without saving / Continue editing
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onDontSave} color="primary">
            Exit without saving
          </Button>
          <Button onClick={onSave} color="primary" autoFocus>
            Continue editing
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

SaveAlertDialog.defaultProps = {
  isConfirmDialoagOpen: false,
  onDontSave: () => {},
  onSave: () => {},
}

SaveAlertDialog.propTypes = {
  isConfirmDialoagOpen: PropTypes.bool,
  onDontSave: PropTypes.func,
  onSave: PropTypes.func,
}

export default SaveAlertDialog
